import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { KeywordService } from 'app/core/keyword/keyword.service';
import { InitialData } from './keyword.types';

@Injectable({
    providedIn: 'root'
})
export class KeywordDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _keywordService: KeywordService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InitialData> {
        return this._keywordService.getKeywords()
        .pipe(
            map((keywords) => ({
                keywords
            })
            ),
            catchError(err => {
                console.log(err);
                
                this._keywordService.errorMessage = err.error.message ? err.error.message : "Something went wrong !";
                return of(new DefaultResponse().keywords);
            })
        );
        
    }

}
class DefaultResponse implements InitialData {
    keywords: any = [];
}